<mat-card appearance="outlined">
	<h4>Reactive Form</h4>
	<form [formGroup]="loginForm" (submit)="$event.preventDefault()">
		<!--<div style="margin-bottom:12px;"><strong>textbox</strong></div>
        <textbox id="email" type="email"
                 [previewData]="true"
                 placeholder="Email"
                 tabOrder="1" formControlName="email" [ahsFormGroup]="loginForm" hint="Take the hint!" label="Email"></textbox>-->
		<div style="margin-bottom: 12px"><strong>ahs-chip-listbox</strong></div>
		<ahs-chip-listbox
			id="fruits"
			[ahsFormGroup]="loginForm"
			appearance="outline"
			placeholder="new fruit"
			[required]="true"
			[previewData]="true"
		></ahs-chip-listbox>

		<div style="margin-bottom: 12px"><strong>ahs-switch</strong></div>
		<ahs-switch
			id="switch"
			[ahsFormGroup]="loginForm"
			appearance="outline"
			[previewData]="true"
			[showYesThenNo]="true"
		>
		</ahs-switch>

		<div style="margin-bottom: 12px"><strong>ahs-text</strong></div>
		<ahs-text
			id="email"
			type="email"
			[previewData]="true"
			placeholder="Email"
			tabOrder="1"
			[ahsFormGroup]="loginForm"
			label="Email"
			appearance="outline"
			[floatLabel]="$any(floatLabel)"
			[allowClear]="true"
		></ahs-text>

		<div style="margin-bottom: 12px"><strong>ahs-masked-text</strong></div>
		<ahs-masked-text
			id="phone"
			[previewData]="true"
			mask="(000) 000-0000"
			tabOrder="1"
			[ahsFormGroup]="loginForm"
			hint="Take the hint!"
			label="Phone Number"
			appearance="outline"
		></ahs-masked-text>

		<div style="margin-bottom: 12px"><strong>ahs-select</strong></div>
		<div style="margin-bottom: 12px" (click)="readonly = !readonly">Toggle ReadOnly</div>
		<ahs-select
			id="select"
			[readonly]="readonly"
			[previewData]="true"
			placeholder="Email"
			[ahsFormGroup]="loginForm"
			hint="Take the hint!"
			label="Email"
			appearance="outline"
			[options]="options"
		></ahs-select>

		<!--<mat-form-field class="full-width">
            <mat-select placeholder="" formControlName="select">
                <mat-option>--</mat-option>
                <mat-option *ngFor="let opt of options" [value]="opt.value">
                    {{opt.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>-->

		<div style="margin-bottom: 12px"><strong>ahs-datepicker</strong></div>
		<ahs-datepicker
			id="date"
			[previewData]="true"
			placeholder="Date Picker"
			tabOrder="1"
			[ahsFormGroup]="loginForm"
			hint="Take the hint!"
			label="Date Picker"
			appearance="outline"
		></ahs-datepicker>

		<div style="margin-bottom: 12px"><strong>ahs-textarea</strong></div>
		<ahs-textarea
			id="textarea"
			[previewData]="true"
			placeholder="Data"
			tabOrder="1"
			[ahsFormGroup]="loginForm"
			hint="Take the hint!"
			label="textarea"
			appearance="outline"
			[rows]="5"
		></ahs-textarea>

		<div style="margin-bottom: 12px"><strong>ahs-autocomplete</strong></div>
		<ahs-autocomplete
			id="autocomplete"
			[previewData]="true"
			placeholder="Autocomplete"
			tabOrder="1"
			[ahsFormGroup]="loginForm"
			hint="Take the hint autocomplete!"
			label="Autocomplete"
			appearance="outline"
			[options]="options"
		>
		</ahs-autocomplete>

		<div style="margin-bottom: 12px"><strong>ahs-radiolist</strong></div>
		<ahs-radiolist
			id="radioList"
			[previewData]="true"
			placeholder="Radio List"
			[ahsFormGroup]="loginForm"
			hint="Take the hint RadioList!"
			label="RadioList"
			appearance="outline"
			[options]="options"
			[defaultValue]="radioValue"
			[flexFlow]="'column'"
			[rightOptionPadding]="'10px'"
		></ahs-radiolist>

		<ahs-checklist
			id="checklist"
			[previewData]="true"
			placeholder="Check List"
			[ahsFormGroup]="loginForm"
			hint="Take the hint Checklist!"
			label="Checklist"
			appearance="outline"
			[options]="checkOptions"
		></ahs-checklist>
	</form>
</mat-card>
